module.exports = __webpack_public_path__ + "media/images/jamicons/more-horizontal-f-6bc9b695c659de890ca36db35e8700e4.svg";